/**
 * Configuração dos filtros para a listagem de pedidos
 */
export const filterConfig = [
  {
    id: 'categoria',
    type: 'text',
    label: 'Categoria',
    placeholder: 'Digite a categoria do benefício',
  }
];
